import { Button, Environment, User, localForageHelper, onEnvironmentChange, onUserChange } from '@hub/shared'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './token-renewal-box.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  idProfile: string
  socialNetwork: string
  onEmitTokenValid?: (tokenValid: boolean) => any
}

export default ({ idProfile, socialNetwork, className = '', onEmitTokenValid }: Props) => {
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const onEnviromentChange = useRef<SubscriptionLike | undefined>(undefined)
  const [authUrl, setAuthUrl] = useState('')
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  const onRenewToken = useCallback(
    async (idProfile, socialNetwork) => {
      await localForageHelper.setItem('actions', { action: 'renew', idProfile })
      window.location.href = `${authUrl}/${socialNetwork === 'instagram' ? 'facebook' : socialNetwork}?squid-callback=${
        window.location.href
      }`
    },
    [authUrl]
  )

  const [t] = useTranslation('tokenRenewalBox')

  const isTokenValid = useMemo(
    () =>
      user?.statusProviders?.[socialNetwork === 'youtube' ? 'google-oauth2' : socialNetwork]?.find((profile) => profile?.id === idProfile)
        ?.tokenExpired === false,
    [idProfile, socialNetwork, user?.statusProviders]
  )

  const isMacro = useMemo(
    () => !!user?.[socialNetwork]?.find((profile) => profile?.id === idProfile)?.macro,
    [user, idProfile, socialNetwork]
  )

  useEffect(() => {
    onEnviromentChange.current = onEnvironmentChange.subscribe((environment: Environment) => {
      setAuthUrl(environment?.squidApis?.proxy)
    })

    return () => onEnviromentChange.current.unsubscribe()
  }, [])

  useEffect(() => {
    if (onEmitTokenValid && typeof onEmitTokenValid === 'function') {
      onEmitTokenValid(isTokenValid)
    }
  }, [isTokenValid, onEmitTokenValid])

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe((userChanged: User) => {
      setUser(userChanged)
      setIsLoading(false)
    })

    return () => onUserChangeSubscription.current.unsubscribe()
  }, [])

  if (isTokenValid) {
    return <div />
  }

  return (
    !isTokenValid &&
    !isMacro && (
      <div className={`token-renewal-box ${className}`}>
        <h5 className="header m-0">
          <i className="fa-solid fa-diamond-exclamation" style={{ color: 'var(--gold)' }}></i>
          {t('expiredLink')}
        </h5>
        <p className="description">{t('description')}</p>
        <Button width="100%" onClick={() => onRenewToken(idProfile, socialNetwork)} loading={isLoading}>
          {t('renewToken')}
        </Button>
      </div>
    )
  )
}
